import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";
import "./Configurator.css";
import {
  getConfiguration,
  getCountertop,
  getCountertops,
  getModule,
  getModules,
} from "../../services/api";
import cabinets from "../../assets/svg/cabinets.svg";
import arrow from "../../assets/svg/arrow.svg";
import removeIcon from "../../assets/svg/removeIcon.svg";
import insertIcon from "../../assets/svg/insertIcon.svg";
import print from "../../assets/svg/print.svg";
import axios from "axios";
import ConfiguratorModal from "../../components/ConfiguratorModal/ConfiguratorModal";
import TopViewModal from "../../components/TopViewModal/TopViewModal";
import PartsList from "../../components/PartsList/PartsList";
import SubmitForm from "../../components/SumbitForm/SubmitForm";
import ModalClose from "../../assets/svg/ModalClose.svg";
import Loader from "../../assets/images/loader.gif";
import { useLanguage } from "../../context/Language";
import compressImage from "../../services/compress";
import resizeImage from "../../services/resize";

const Configurator = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [configuratorElements, setConfiguratorElements] = useState(() => {
    const saved = localStorage.getItem("configuratorElements");
    const initialValue = saved ? JSON.parse(saved) : [];
    return initialValue;
  });

  const [modules, setModules] = useState();
  const [isConfigurationModalOpen, setIsConfigurationModalOpen] =
    useState(false);
  const [isTopViewModalOpen, setIsTopViewModalOpen] = useState(false);
  const [isPartsListModalOpen, setIsPartsListModalOpen] = useState(false);
  const [insertAtIndex, setInsertAtIndex] = useState(null);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [counterTop, setCounterTop] = useState({});
  const [width, setWidth] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);
  const [countertopOn, setCountertopOn] = useState(false);
  const { language, isENG, toggleLanguage } = useLanguage();
  const [alertModal, setAlertModal] = useState(false);
  const [screenshot, setScreenshot] = useState("");
  const toggleAlertModal = () => {
    setAlertModal(!alertModal);
  };
  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };
  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const openConfigModal = () => {
    setIsConfigurationModalOpen(true);
  };
  const clearLocalStorage = () => {
    localStorage.clear();
  };
  const closeConfigModal = () => {
    setIsConfigurationModalOpen(false);
  };
  const clearNavigation = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  //Get all modules
  const fetchModules = async () => {
    const selectedColor = localStorage.getItem("selectedModuleColor");
    const allmodules = await getModules(selectedColor);
    setModules(allmodules.data);
  };

  //Get all countertops
  const fetchCounterTops = async () => {
    const selectedCounterTopColor = localStorage.getItem(
      "selectedCounterTopColor"
    );
    const res = await getCountertops(selectedCounterTopColor);
    setCounterTop(res.data);
  };
  //If there is a dealer code in the localstorage, load a configuration using the dealer code
  const fetchConfiguration = async () => {
    try {
      setIsLoading(true);
      const configId = localStorage.getItem("Dealer code");

      if (configId) {
        const res = await getConfiguration(configId);

        if (res.data && res.data.length > 0 && res.data[0]) {
          const configItems = res.data[0].configItem;
          if (configItems && configItems.length > 0) {
            let cumulativeWidth = 0;

            const updatedConfiguratorElements = [];

            for (const configItem of configItems) {
              const moduleID = configItem.module.id;
              const counterTopID = configItem.module.counter_top.id;
              const hasCounterTop = configItem.hasCounterTop;

              const selectedModuleColor = localStorage.getItem(
                "selectedModuleColor"
              );
              const moduleData = await getModule(moduleID, selectedModuleColor);

              cumulativeWidth += moduleData.data[0].width;

              let moduleDetails = {
                id: moduleData.data[0].id,
                image: `${moduleData.data[0].options[0].render.url}`,
                topView: `${moduleData.data[0].options[0].topView.url}`,
                counterTopId: moduleData.data[0].counter_top.id,
                hasCounterTop: hasCounterTop,
                title: moduleData.data[0].title,
                titleDE: moduleData.data[0].titleDE,
                moduleDepth: moduleData.data[0].depth,
                moduleWidth: moduleData.data[0].width,
                moduleHeight: moduleData.data[0].height,
                articleNumber: moduleData.data[0].articleNumber,
                totalCurrentWidth: cumulativeWidth,
              };

              let counterTopDetails = null;
              if (counterTopID) {
                const selectedCounterTopColor = localStorage.getItem(
                  "selectedCounterTopColor"
                );
                const countertopData = await getCountertop(
                  counterTopID,
                  selectedCounterTopColor
                );
                setWidth(parseInt(cumulativeWidth));

                counterTopDetails = {
                  id: counterTopID,
                  render: `${countertopData?.data[0]?.options[0]?.render.url}`,
                  topView: `${countertopData?.data[0]?.options[0]?.topView.url}`,
                  name: countertopData?.data[0]?.title,
                  nameDE: countertopData?.data[0]?.titleDE,
                };
              }

              updatedConfiguratorElements.push({
                ...moduleDetails,
                counterTop: counterTopDetails,
              });
            }

            setConfiguratorElements(updatedConfiguratorElements);

            localStorage.setItem(
              "selectedModuleColor",
              res.data[0].moduleColor
            );
            localStorage.setItem(
              "selectedCounterTopColor",
              res.data[0].counterTopOption
            );
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const selectedColor = localStorage.getItem("selectedModuleColor");

  useEffect(() => {
    fetchModules();
    fetchCounterTops();
    try {
      fetchConfiguration();
    } catch (error) {
      console.error(error);
    }
  }, [selectedColor]);
  const addModuleToElements = (element) => {
    setConfiguratorElements((prevElements) => {
      if (prevElements.length > 7) {
        setInsertAtIndex(null);
        setAlertModal(true);
        return prevElements;
      }
      let newElements;

      if (prevElements.length === 0) {
        newElements = [element];
      } else {
        newElements = [...prevElements];

        if (insertAtIndex !== null) {
          newElements.splice(insertAtIndex, 0, element);
          setInsertAtIndex(null);
        } else {
          if (newElements.length > 7) {
            alert("Cannot add more modules");
            return prevElements;
          } else {
            newElements.push(element);
          }
        }
      }

      let accumulatedWidth = 0;
      return newElements.map((el) => {
        const moduleWidth = parseInt(el.moduleWidht, 10);
        if (!isNaN(moduleWidth)) {
          accumulatedWidth += moduleWidth;
        }

        return { ...el, totalCurrentWidth: accumulatedWidth };
      });
    });
  };

  const addCounterTopToModule = async (index) => {
    const selectedCounterTopColor = localStorage.getItem(
      "selectedCounterTopColor"
    );

    if (selectedCounterTopColor) {
      try {
        const counterTopId = configuratorElements[index].counterTopId;
        const countertopData = await getCountertop(
          counterTopId,
          selectedCounterTopColor
        );
        if (countertopData.data && countertopData.data.length > 0) {
          const render = countertopData.data[0].options[0].render.url;
          const topView = countertopData.data[0].options[0].topView.url;

          setConfiguratorElements((prevElements) => {
            const newElements = [...prevElements];
            const moduleToUpdate = newElements[index];

            if (!moduleToUpdate.hasCounterTop) {
              const updatedModule = {
                ...moduleToUpdate,
                hasCounterTop: true,
                counterTop: {
                  render: `${render}`,
                  topView: `${topView}`,
                },
              };

              newElements[index] = updatedModule;
            }

            return newElements;
          });
        } else {
          console.error(
            "No countertop data found for module with ID:",
            counterTopId
          );
        }
      } catch (error) {
        console.error("Error fetching countertop data:", error);
      }
    }
  };

  const removeCounterTopFromModule = (index) => {
    setConfiguratorElements((prevElements) => {
      const newElements = [...prevElements];
      const moduleToUpdate = newElements[index];
      if (moduleToUpdate.counterTop) {
        delete moduleToUpdate.counterTop;
        moduleToUpdate.hasCounterTop = false;
      }
      return newElements;
    });
  };

  const removeModuleFromElements = (index) => {
    setConfiguratorElements((prevElements) => {
      let newElements = [...prevElements];
      newElements.splice(index, 1);

      let accumulatedWidth = 0;
      newElements = newElements.map((element) => {
        accumulatedWidth += parseInt(element.moduleWidht, 10);
        return { ...element, totalCurrentWidth: accumulatedWidth };
      });

      return newElements;
    });
  };

  const configId = localStorage.getItem("Dealer code");
  const payload = {
    data: {
      configId: configId,
      configItem: configuratorElements.map((element, index) => {
        const moduleID = element.id;
        const hasCounterTop = element.hasCounterTop;
        return {
          hasCounterTop: hasCounterTop,
          price: element.price,
          __temp_key__: index + 1,
          module: {
            disconnect: [],
            connect: [{ id: moduleID, position: { end: true } }],
          },
        };
      }),
      moduleColor: localStorage.getItem("selectedModuleColor"),
      counterTopOption: localStorage.getItem("selectedCounterTopColor"),
    },
  };

  const handleSubmit = async (generatedDealerCode = null) => {
    const configItems = payload.data.configItem;
    let total = 0;
    configItems.forEach((item) => {
      total += item.price;
    });
  
    payload.data.totalModulePrice = total.toString();
    if (generatedDealerCode) {
      payload.data.configId = generatedDealerCode;
    }
  
    const screenshot = localStorage.getItem("screenshot");
  
    const apiUrl = "https://parekitchenbackend.onrender.com/api/configurations";
    try {
      const existingConfig = await getConfiguration(payload.data.configId);
  
      if (existingConfig.data && existingConfig.data.length > 0) {
        const updateUrl = `${apiUrl}/${existingConfig.data[0].id}`;
        await axios.put(updateUrl, { ...payload, screenshot });
      } else {
        await axios.post(apiUrl, { ...payload, screenshot }, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      }
    } catch (error) {
      console.error("Error updating/creating the configuration:", error);
    }
  };
  

  const openInsertModal = (index) => {
    setInsertAtIndex(index);
  };

  const handleFormSubmitSuccess = () => {
    handleSubmit();
    setIsContactModalOpen(false);
  };

  const handleDragStart = (e, index) => {
    setDraggedItemIndex(index);
    const hasCounterTop = configuratorElements[index]?.hasCounterTop;
    e.dataTransfer.effectAllowed = "move";
    if (hasCounterTop) {
      if (e.dataTransfer.setDragImage) {
        var img = new Image();
        img.src =
          "data:image/png;base64,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"; // 1x1 transparent GIF
        e.dataTransfer.setDragImage(img, 20, 20);
      } else {
        console.log("Browser does not support setting a custom drag image.");
      }
    }
    // Prevent any drag image from showing
    if (e.dataTransfer.setDragImage) {
      img = new Image();
      img.src =
        "data:image/png;base64,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";
      e.dataTransfer.setDragImage(img, 20, 20);
    } else {
      console.log("Browser does not support setting a custom drag image.");
    }
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();

    const target = e.currentTarget; // The module being dragged over
    const targetRect = target.getBoundingClientRect(); // Dimensions of the module
    const targetMiddleY = (targetRect.bottom - targetRect.top) / 2; // Middle Y position
    const mousePositionY = e.clientY - targetRect.top; // Mouse Y position within the module

    // Determine if the drag is in the upper or lower half of the module
    const dragPosition = mousePositionY < targetMiddleY ? "upper" : "lower";

    // Only proceed if the dragged item index is defined and it's different from the current index
    if (draggedItemIndex !== null && index !== draggedItemIndex) {
      let newIndex = index;

      // Adjust the index for lower half drag overs
      if (dragPosition === "lower" && index < configuratorElements.length - 1) {
        newIndex = index + 1;
      }

      if (newIndex !== draggedItemIndex) {
        const newConfiguratorElements = [...configuratorElements];
        const itemBeingMoved = newConfiguratorElements.splice(
          draggedItemIndex,
          1
        )[0];
        newConfiguratorElements.splice(newIndex, 0, itemBeingMoved);
        setConfiguratorElements(newConfiguratorElements);
        setDraggedItemIndex(newIndex);
      }
    }
  };

  const handleDrop = (e, index) => {
    e.preventDefault();

    setDraggedItemIndex(null);
  };

  const handleDragEnd = () => {
    setDraggedItemIndex(null);
  };
  const saveScreenshot = async () => {
    const modulesDiv = document.querySelector(".modules");
    html2canvas(modulesDiv, {
      scale: 1, // Reduce the scale to reduce size
      backgroundColor: null,
      useCORS: true,
    })
      .then(async (canvas) => {
        let image = canvas.toDataURL("image/png");
        image = await compressImage(image); // Compress the image
        image = await resizeImage(image); // Resize the image
        localStorage.setItem("screenshot", image);
      })
      .catch((err) => {
        console.error("Error capturing screenshot:", err);
      });
  };
  useEffect(() => {
    saveScreenshot();
  }, [configuratorElements]);

  useEffect(() => {
    saveScreenshot();
  }, [configuratorElements]);
  const downloadModulesScreenshot = () => {
    // Get the element you want to capture
    const modulesDiv = document.querySelector(".modules");

    html2canvas(modulesDiv, {
      scale: 2,
      backgroundColor: null,
      useCORS: true,
    })
      .then((canvas) => {
        const image = canvas.toDataURL("image/png");
        localStorage.setItem("screenshot", image);
        triggerDownload(image, "PareKitchen Configuration.png");
      })
      .catch((err) => {
        console.error("Error capturing screenshot:", err);
      });
  };

  function triggerDownload(imgURL, fileName) {
    const a = document.createElement("a");
    a.href = imgURL;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const maxModuleHeight = configuratorElements.reduce((maxHeight, element) => {
    const currentHeight = parseInt(element.moduleHeight, 10);

    return Math.max(maxHeight, currentHeight);
  }, 0);
  const toggleAllCountertops = async () => {
    if (!countertopOn) {
      const updatedElements = await Promise.all(
        configuratorElements.map(async (element) => {
          if (
            !element.hasCounterTop &&
            element.counterTopId &&
            element.counterTopId !== 1
          ) {
            try {
              const selectedCounterTopColor = localStorage.getItem(
                "selectedCounterTopColor"
              );
              const countertopData = await getCountertop(
                element.counterTopId,
                selectedCounterTopColor
              );

              if (
                countertopData &&
                countertopData.data &&
                countertopData.data.length > 0
              ) {
                const renderUrl = countertopData.data[0].options[0].render.url;
                const topViewUrl =
                  countertopData.data[0].options[0].topView.url;
                return {
                  ...element,
                  hasCounterTop: true,
                  counterTop: {
                    render: renderUrl,
                    topView: topViewUrl,
                  },
                };
              } else {
                return { ...element, hasCounterTop: true };
              }
            } catch (error) {
              console.error("Error fetching countertop data:", error);
              return { ...element, hasCounterTop: false };
            }
          } else {
            return element;
          }
        })
      );

      setConfiguratorElements(updatedElements);
      setCountertopOn(true);
    } else {
      const updatedElements = configuratorElements.map((element) => ({
        ...element,
        hasCounterTop: false,
        counterTop: null,
      }));

      setConfiguratorElements(updatedElements);
      setCountertopOn(false);
    }
  };

  useEffect(() => {
    localStorage.setItem(
      "configuratorElements",
      JSON.stringify(configuratorElements)
    );
  }, [configuratorElements]);
  return (
    <div className="configuratorWrapper">
      <div className="configurator">
        <div className="buttons">
          <Link className="goback" onClick={clearLocalStorage} to={"/"}>
            <img src={arrow} alt="" />{" "}
            <span> {isENG ? "Back" : "Zurück"} </span>
          </Link>
          <div className="print_topview">
            <div
              className="print"
              onClick={() => {
                downloadModulesScreenshot();
              }}
            >
              <img src={print} alt="" />
            </div>
            {/* {!countertopOn ? (
              <p onClick={addAllCounterTops}>Add countertops</p>
            ) : (
              <p onClick={removeAllCounterTops}>Remove countertops</p>
            )} */}
            <p onClick={toggleAllCountertops}>
              {countertopOn
                ? `${isENG ? "Remove Countertops" : "Arbeitsplatte entfernen"}`
                : `${isENG ? "Add Countertops" : "Arbeitsplatte hinzufügen"}`}
            </p>

            {/* <p
              onClick={() => {
                handleSubmit();
                // downloadConfiguratorImage();
                setShowSuccessModal(true);
              }}
            >
              Speichern
            </p> */}

            <p onClick={() => setIsTopViewModalOpen(true)}>
              {isENG ? "Topview" : "Draufsicht"}
            </p>
            <p onClick={openConfigModal}>
              {isENG ? "Configuration" : "Konfiguration"}
            </p>
            <p onClick={clearNavigation}>{isENG ? "Reset" : "Zurücksetzen"}</p>
            <p className="languageButton" onClick={toggleLanguage}>
              {language}
            </p>
          </div>
        </div>

        <div className="modules" onDragOver={(e) => e.preventDefault()}>
          {isLoading ? (
            <img src={Loader} alt="loader" className="loader" /> // Show loading text
          ) : (
            <div className="elementsContainer">
              {configuratorElements.length > 0 && (
                <div className="heightLineWrapper">
                  <div className="heightLineNumbers">
                    <div className="segWidth2">{maxModuleHeight}</div>
                    <p className="segWidth"></p>
                    <p className="segWidth">0</p>
                  </div>

                  <div className="heightLineOrientation">
                    <div className="segEnd"></div>
                    <div className="heightLine"></div>
                    <div className="segStart"></div>
                  </div>
                </div>
              )}
              {configuratorElements.length < 1 ? (
                <p className="informationText">
                  {isENG
                    ? "Please select one of the modules"
                    : "Bitte wählen Sie eines der Module aus"}
                </p>
              ) : null}
              {configuratorElements.map((element, index) => {
                let cumulativeWidth = 0;
                for (let i = 0; i <= index; i++) {
                  cumulativeWidth +=
                    parseInt(configuratorElements[i].moduleWidth, 10) || 0;
                }

                return (
                  <div key={index}>
                    <div
                      key={element.id} // Assuming each element has a unique 'id' property
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragOver={(e) => handleDragOver(e, index)}
                      onDrop={(e) => handleDrop(e, index)}
                      onDragEnd={handleDragEnd}
                      className="moduleItem"
                    >
                      {element.hasCounterTop === true && (
                        <div className="counterTopItem">
                          <button
                            onClick={() => removeCounterTopFromModule(index)}
                            className="removeCounterTopButton"
                          >
                            Arbeitsplatte entfernen
                          </button>
                          <img
                            src={element.counterTop.render}
                            alt={`Countertop ${index}`}
                            className="countertopImage"
                          />
                        </div>
                      )}

                      {element.hasCounterTop === false &&
                        element.counterTopId !== 1 && (
                          <button
                            onClick={() => addCounterTopToModule(index)}
                            className="addCounterTopButton"
                          >
                            Arbeitsplatte hinzufügen
                          </button>
                        )}

                      <img
                        src={element.module ? element.image : element.image}
                        key={index}
                        alt={`Element ${index}`}
                        className="moduli"
                      />
                      <div
                        className="removeIcon"
                        onClick={() => removeModuleFromElements(index)}
                      >
                        <img
                          src={removeIcon}
                          alt="removeIcon"
                          className="removeIcon"
                        />
                      </div>
                      {index !== configuratorElements.length && (
                        <div
                          className="insertIcon"
                          onClick={() => openInsertModal(index)}
                        >
                          <img
                            src={insertIcon}
                            alt="insertIcon"
                            className="insertIcon"
                          />
                        </div>
                      )}
                    </div>

                    <div className="lineWrapper">
                      {index === 0 && <div className="segStart"></div>}
                      <div className="line"></div>
                      <div className="segEnd"></div>
                    </div>
                    <div className="numbersWrapper">
                      {index === 0 && <p className="segWidth">0</p>}{" "}
                      {index !== 0 && <p className="segWidth"></p>}
                      <div className="segWidth2">{cumulativeWidth}</div>
                    </div>

                    <div></div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="cabinets">
        <p className="cabinetsTitle">
          <img src={cabinets} alt="" /> {isENG ? "Cabinets" : "Module"}
        </p>
        <div className="wrapper">
          {modules?.map((element, index) => (
            <div
              className="module"
              key={index}
              onClick={() => {
                const imageUrl = element?.options[0]?.render?.url;
                const topViewUrl = element?.options[0]?.topView?.url;
                const moduleId = element?.id;
                const articleNumber = element?.articleNumber;
                const title = element?.title;
                const titleDE = element?.titleDE;

                const counterTopId = element?.counter_top?.id;
                const ruleIdentifier = element?.ruleIdentifier;
                const moduleWidth = element?.width;
                const moduleDepth = element?.depth;
                const moduleHeight = element?.height;
                const price = element?.price;

                if (moduleId !== undefined) {
                  const totalCurrentWidth =
                    parseInt(width) + parseInt(moduleWidth);
                  setWidth(totalCurrentWidth);
                  addModuleToElements({
                    id: moduleId,
                    counterTopId: counterTopId,
                    image: imageUrl,
                    topView: topViewUrl,
                    articleNumber: articleNumber,
                    name: title,
                    nameDE: titleDE,
                    hasCounterTop: false,
                    ruleIdentifier: ruleIdentifier,
                    moduleWidth: moduleWidth,
                    moduleDepth: moduleDepth,
                    moduleHeight: moduleHeight,
                    price: price,
                    totalCurrentWidth: parseInt(totalCurrentWidth),
                  });
                }
              }}
            >
              <div className="imgWrapper">
                <img src={"" + element.options[0].thumbnail.url} alt="" />
              </div>
              <h6>{isENG ? `${element?.title}` : `${element?.titleDE}`} </h6>
              <p>
                {isENG
                  ? `${element?.description}`
                  : `${element?.descriptionDE}`}
              </p>
            </div>
          ))}
        </div>
        <div className="parts-inquiry">
          <p className="white" onClick={() => setIsPartsListModalOpen(true)}>
            {isENG ? "Parts list" : "Teileliste"}
          </p>
          <p className="black" onClick={() => openContactModal()}>
            {isENG ? "Send Inqury" : "Anfrage versenden"}
          </p>
        </div>
      </div>

      <TopViewModal
        isOpen={isTopViewModalOpen}
        configuratorElements={configuratorElements}
        closeModal={() => setIsTopViewModalOpen(false)}
      />
      <PartsList
        isOpen={isPartsListModalOpen}
        closeModal={() => setIsPartsListModalOpen(false)}
        configuratorElements={configuratorElements}
      />
      <ConfiguratorModal
        isOpen={isConfigurationModalOpen}
        closeModal={closeConfigModal}
        takeScreenshot={downloadModulesScreenshot}
        saveConfigurator={async () => {
          if (configuratorElements.length === 0) {
            alert(
              isENG ? "No modules to save." : "Keine Module zum Speichern."
            );
            return;
          }

          saveScreenshot();
          await handleSubmit(localStorage.getItem("Dealer code"));
          setShowSuccessModal(true);
        }}
        dealerCode={localStorage.getItem("Dealer code")}
      />

      <SubmitForm
        isOpen={isContactModalOpen}
        closeModal={closeContactModal}
        onSubmitSuccess={handleFormSubmitSuccess}
        screenshot={screenshot}
      />

      {insertAtIndex !== null && (
        <div className="cabinetSelectionModal">
          <div className="cabinetsModal">
            <p className="cabinetsTitle">
              <img src={cabinets} alt="" /> {isENG ? "Cabinets" : "Module"}
            </p>
            <div className="selectWrapper">
              {modules?.map((element, index) => (
                <div
                  className="insertModule"
                  key={index}
                  onClick={() => {
                    const imageUrl = "" + element?.options[0]?.render?.url;
                    const topViewUrl = "" + element?.options[0]?.topView?.url;
                    const moduleId = element?.id;
                    const articleNumber = element?.articleNumber;
                    const title = element?.title;
                    const titleDE = element?.titleDE;
                    const counterTopId = element?.counter_top?.id;
                    const moduleWidth = element?.width;
                    const moduleDepth = element?.depth;
                    const moduleHeight = element?.height;
                    const price = element?.price;
                    if (moduleId !== undefined) {
                      addModuleToElements({
                        id: moduleId,
                        counterTopId: counterTopId,
                        image: imageUrl,
                        topView: topViewUrl,
                        articleNumber: articleNumber,
                        name: title,
                        nameDE: titleDE,
                        hasCounterTop: false,
                        moduleWidth: moduleWidth,
                        moduleDepth: moduleDepth,
                        moduleHeight: moduleHeight,
                        price: price,
                      });
                    }
                  }}
                >
                  <div className="imgWrapper">
                    <img
                      src={"" + element.options[0].thumbnail.url}
                      alt="moduleImages"
                    />
                  </div>
                  <h6>
                    {isENG ? `${element?.title}` : `${element?.titleDE}`}{" "}
                  </h6>
                  <p>
                    {isENG
                      ? `${element?.description}`
                      : `${element?.descriptionDE}`}
                  </p>
                </div>
              ))}
            </div>
            <p
              className="cancelButton"
              onClick={() => {
                setInsertAtIndex(null);
              }}
            >
              {isENG ? "CANCEL" : "ABBRECHEN"}
            </p>
          </div>
        </div>
      )}

      {/* {showSuccessModal && (
        <div className="succesModal">
          <div className="successWrapper">
            <img src={ModalClose} onClick={closeSuccessModal} alt="close" />
            <div className="successContainer">
              <div className="successContent">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <path
                    d="M55 27.7V30C54.9969 35.3911 53.2513 40.6367 50.0233 44.9546C46.7954 49.2725 42.2582 52.4312 37.0884 53.9598C31.9186 55.4883 26.3931 55.3048 21.3362 53.4365C16.2792 51.5682 11.9616 48.1153 9.0274 43.5927C6.09317 39.0701 4.69948 33.7202 5.05419 28.3408C5.40891 22.9614 7.49302 17.8408 10.9957 13.7427C14.4984 9.64458 19.232 6.78848 24.4905 5.60039C29.749 4.4123 35.2507 4.95587 40.175 7.15003"
                    stroke="#F49800"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M55 10L30 35.025L22.5 27.525"
                    stroke="#F49800"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="successText">
                  {isENG ? "Success! " : "Gespeichert!"}
                </p>
                <div className="successDescription">
                  {isENG
                    ? `The configuration with the dealer code ${localStorage.getItem(
                        "Dealer code"
                      )} as been saved successfully.`
                    : `Die Konfiguration mit dem Händlercode ${localStorage.getItem(
                        "Dealer code"
                      )} wurde erfolgreich gespeichert.`}
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {alertModal && (
        <div className="succesModal">
          <div className="successWrapper">
            <img src={ModalClose} onClick={toggleAlertModal} alt="close" />
            <div className="successContainer">
              <div className="successContent">
                <div className="alertDescription">
                  {isENG
                    ? "A maximum of 8 modules can be added."
                    : "Es können nicht mehr als 8 Module hinzugefügt werden."}
                </div>
              </div>
            </div>
            <button className="alertButton" onClick={toggleAlertModal}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// function generateRandomNumber() {
//   const min = 100000;
//   const max = 999999;
//   const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
//   return randomNumber.toString();
// }

export default Configurator;
